import { AUTH_STORAGE_KEY } from "./auth";
import { SERVICE_STORAGE_KEY } from "./service";
import { REGISTRATION_STORAGE_KEY } from "./registration";

const sessionStoragePlugin = store => {
  store.subscribe((mutation, state) => {
    const syncedRegistrationData = {
      user: state.registration.user,
      identities: state.registration.identities
    };

    const syncedAuthData = {
      isLoggedIn: state.auth.isLoggedIn,
      accessToken: state.auth.accessToken,
      idToken: state.auth.idToken,
      refreshToken: state.auth.refreshToken,
      user: state.auth.user
    };

    const syncedServiceData = {
      centre: state.service.centre,
      educatorUser: state.service.educatorUser,
      registerCentre: state.service.registerCentre
    };
    sessionStorage.setItem(
      REGISTRATION_STORAGE_KEY,
      JSON.stringify(syncedRegistrationData)
    );
    sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(syncedAuthData));
    sessionStorage.setItem(
      SERVICE_STORAGE_KEY,
      JSON.stringify(syncedServiceData)
    );
    if (mutation.type == "CLEAR_EDUCATOR") {
      sessionStorage.setItem(
        SERVICE_STORAGE_KEY,
        JSON.stringify({
          centre: state.service.centre,
          educatorUser: {
            userFirstName: "",
            userLastName: "",
            userPreferredName: "",
            userEmail: "",
            userEmailConfirmation: "",
            userMobile: ""
          },
          registerCentre: state.service.registerCentre
        })
      );
    }
    if (mutation.type === "CLEAR_AUTH") {
      sessionStorage.removeItem(AUTH_STORAGE_KEY);
      sessionStorage.removeItem(SERVICE_STORAGE_KEY);
    }
    if (mutation.type === "CLEAR_REGISTRATION") {
      sessionStorage.removeItem(REGISTRATION_STORAGE_KEY);
    }
  });
};

export default [sessionStoragePlugin];
